/* eslint camelcase: 0 */
import { getBackVersion } from '../config';
import api from './api';

const setFavorite = (
    listingId: string,
    isFavorite: boolean
): Promise<boolean> => {
    return api
        .request<{ isFavorite: boolean }>({
            method: 'POST',
            url: `${getBackVersion()}/listings/` + listingId + '/favorite',
            data: { is_favorite: isFavorite },
        })
        .then(x => x.isFavorite);
};

export default { setFavorite };
